import * as Models from './'

export interface IGroupModel {
  groupId: string;
  name: string;
  partner: Models.PartnerModel.IPartnerModel;
  suspendWorkIssueNotification: boolean;
  roles: Array<Models.RoleModel.IRoleModel>;
  users: Array<Models.UserModel.IUserModel>;
  rejectionEmailDistro: string;
  cancellationEmailDistro: string;
  groupTypeId: number;
}

export class GroupModel implements IGroupModel {
  groupId: string;
  name: string;
  partner: Models.PartnerModel.PartnerModel;
  suspendWorkIssueNotification: boolean;
  roles: Array<Models.RoleModel.RoleModel> = new Array<Models.RoleModel.RoleModel>();
  users: Array<Models.UserModel.UserModel> = new Array<Models.UserModel.UserModel>();
  rejectionEmailDistro: string;
  cancellationEmailDistro: string;
  groupTypeId: number;

  constructor(name: string, partner: Models.PartnerModel.PartnerModel, rejectionEmailDistro: string, cancellationEmailDistro: string) {
    this.name = name;
    this.partner = partner;
    this.rejectionEmailDistro = rejectionEmailDistro;
    this.cancellationEmailDistro = cancellationEmailDistro;
  }
}

export interface IGroupSummaryModel {
  groupId: string;
  name: string;
}
